import { render } from "./jiaoyisheding.vue?vue&type=template&id=5030212b&scoped=true"
import script from "./jiaoyisheding.vue?vue&type=script&lang=js"
export * from "./jiaoyisheding.vue?vue&type=script&lang=js"

import "./jiaoyisheding.vue?vue&type=style&index=0&id=5030212b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5030212b"]])

export default __exports__